import { cn } from "cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        /* sorted */
        "bg-bg-dark-min rounded-md",
        "animate-pulse",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
